export default __webpack_public_path__ + "static/media/img-1.2ed33261.png";